export const blockIconsSocialHealthAndSafety = (
	<span className='material-symbols-outlined'>health_and_safety</span>
);
